// [PURPOSE]: Single entry point for copying text to the clipboard.
// [WHY]: Spec 2026-05-11-party-create-join — multiple places (PostCreate share screen,
//   PartyShareInviteModal) need clipboard writes with a textarea fallback for browsers
//   that don't support navigator.clipboard (older mobile Safari, non-secure contexts).
// [INTEGRATION]: Returns a Promise<boolean> so callers can show "Copied!" feedback.

export async function copyToClipboard(text) {
  if (typeof text !== 'string' || text.length === 0) {
    return false;
  }
  try {
    if (navigator?.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch (_) {
    // fall through to legacy fallback
  }
  if (typeof document === 'undefined') {
    return false;
  }
  try {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return !!ok;
  } catch (_) {
    return false;
  }
}
